
import { Options, Vue } from "vue-class-component";

@Options({
  name: "NotesInput",
  emits: ["update:notes", "save"],
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    notes: {
      type: String,
      default: ""
    },
    isIcon: {
      type: Boolean,
      default: true
    }
  }
})
export default class NotesInput extends Vue {
  onNotesChange(newValue: string): void {
    this.$emit("update:notes", newValue);
  }
}
